"use strict";
export const OCR_LINE_MIME = "application/x-hubtran-ocr-line";
const LINE_SELECTOR = ".o-t";
const DRAGGING_CLASS = "ocr-line-dragging";
const HOVER_CLASS = "ocred-document__drop-target";
const DROPPABLE_ATTR = "data-ocr-droppable";
export function formatDate(value) {
  try {
    return new Date(value).toISOString().slice(0, 10);
  } catch (e) {
    return void 0;
  }
}
export function forceString(value) {
  try {
    return value.toString();
  } catch (e) {
    return null;
  }
}
function parseNumber(value) {
  if (value == null || value === "") {
    return void 0;
  }
  const parsed = Number(value);
  return Number.isNaN(parsed) ? void 0 : parsed;
}
function payloadFromLine(line) {
  var _a, _b;
  const data = line.dataset;
  return {
    // The Elm viewer also sets title to the same text; dataset is the contract.
    chars: (_b = (_a = data.chars) != null ? _a : line.title) != null ? _b : "",
    top: parseNumber(data.top),
    left: parseNumber(data.left),
    width: parseNumber(data.width),
    height: parseNumber(data.height)
  };
}
function carriesOcrLine(dataTransfer) {
  var _a;
  return ((_a = dataTransfer == null ? void 0 : dataTransfer.types) != null ? _a : []).includes(OCR_LINE_MIME);
}
function readPayload(dataTransfer) {
  const raw = dataTransfer == null ? void 0 : dataTransfer.getData(OCR_LINE_MIME);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}
let dragSourceInstalled = false;
export function installOcrLineDragSource() {
  if (dragSourceInstalled || typeof document === "undefined") {
    return;
  }
  dragSourceInstalled = true;
  document.addEventListener(
    "dragstart",
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
      const line = target.closest(LINE_SELECTOR);
      if (!(line instanceof HTMLElement) || !event.dataTransfer) {
        return;
      }
      event.dataTransfer.setData(
        OCR_LINE_MIME,
        JSON.stringify(payloadFromLine(line))
      );
      event.dataTransfer.effectAllowed = "copy";
      document.body.classList.add(DRAGGING_CLASS);
    },
    true
  );
  document.addEventListener(
    "dragend",
    () => document.body.classList.remove(DRAGGING_CLASS),
    true
  );
}
export function attachOcrLineDropListeners(element, onDrop) {
  installOcrLineDragSource();
  const target = element;
  target.setAttribute(DROPPABLE_ATTR, "true");
  const allowDrop = (event) => {
    if (!carriesOcrLine(event.dataTransfer)) {
      return;
    }
    event.preventDefault();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = "copy";
    }
    target.classList.add(HOVER_CLASS);
  };
  const clearHover = () => target.classList.remove(HOVER_CLASS);
  const handleDrop = (event) => {
    const payload = readPayload(event.dataTransfer);
    clearHover();
    if (!payload) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    onDrop(payload, event);
  };
  target.addEventListener("dragenter", allowDrop);
  target.addEventListener("dragover", allowDrop);
  target.addEventListener("dragleave", clearHover);
  target.addEventListener("drop", handleDrop);
  return () => {
    clearHover();
    target.removeAttribute(DROPPABLE_ATTR);
    target.removeEventListener("dragenter", allowDrop);
    target.removeEventListener("dragover", allowDrop);
    target.removeEventListener("dragleave", clearHover);
    target.removeEventListener("drop", handleDrop);
  };
}
